import { useFeatureFlags } from "../../query/hooks/useFeatureFlags";
import { getPayerRows, IPayerRow } from "../../services/search";
import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../utils/serviceHelper";

//https://linear.app/wingspan/issue/WIN-13089
export const MASTER_POLICY_PAYERS_IDS = [
  "_XL8s3f7HJTGx3tO9I_Bbk",
  "2KbpkEQcIJiiUNHNIeglFV"
];

export const useFeatureCheckPayersList = (
  config?: WSQueryConfig<IPayerRow[], WSServiceError>
) =>
  useWSQuery(
    ["FEATURE_CHECK_PAYERS", MASTER_POLICY_PAYERS_IDS],
    async () => {
      return getPayerRows({
        filter: {
          payerId: {
            in: MASTER_POLICY_PAYERS_IDS
          }
        },
        page: {
          number: 1,
          size: 1
        }
      });
    },
    {
      retry: false,
      ...config
    }
  );

export const useShowMasterPolicyFlow = () => {
  const featureFlags = useFeatureFlags();

  const qPayers = useFeatureCheckPayersList({
    enabled: !!featureFlags.data && !featureFlags.data.masterPolicyEnrollment
  });

  return !!featureFlags.data?.masterPolicyEnrollment || !!qPayers.data?.length;
};
